import * as React from "react";

import { Button } from "@/components/ui/button";
import { LucideEye, LucideEyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export interface InputPasswordProps extends React.ComponentProps<"input"> {}

const InputPassword = React.forwardRef<HTMLInputElement, InputPasswordProps>(({ ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <div className="relative">
      <Input ref={ref} type={showPassword ? "text" : "password"} {...props} />
      <div className="absolute right-1 top-1 text-muted-foreground text-sm">
        <Button
          type="button"
          variant="ghost"
          className="h-7 w-7 p-0"
          onClick={() => {
            setShowPassword(showPassword => !showPassword);
          }}
        >
          {showPassword ? <LucideEyeOff className="size-4" /> : <LucideEye className="size-4" />}
        </Button>
      </div>
    </div>
  );
});
InputPassword.displayName = "InputPassword";

export { InputPassword };
